export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1200px] mx-auto">
        <div className="bg-gradient-to-r from-primary-50 via-background-50 to-accent-50 rounded-2xl border border-background-200/60 p-8 md:p-10">
          <div className="text-center max-w-2xl mx-auto">
            <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 mx-auto mb-5">
              <i className="ri-mail-send-line text-2xl text-primary-600"></i>
            </div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              联系我们 / 投稿爆料
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              如果你有独家爆料、娱乐资讯或合作意向，欢迎联系我们。
              51吃瓜网址致力为吃瓜群众提供最新最全的娱乐导航服务，期待您的加入与支持。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
              <a
                href="#faq"
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-chat-1-line"></i>
                查看常见问题
              </a>
              <a
                href="#about"
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 hover:border-primary-300 text-foreground-700 hover:text-primary-600 font-medium text-sm rounded-lg transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-information-line"></i>
                了解更多
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}